module.exports = __webpack_public_path__ + "img/locator.6fda1e17.png";